import { Configuration } from "@/shared-module/models";
import { ConfigurationService } from "@/shared-module/services";
import { Component, Input } from "@angular/core";
import { SubSink } from "subsink";
import { Userpilot } from "userpilot";

@Component({
  selector: "app-needhelp-button",
  templateUrl: "needhelpbutton.component.html",
})
export class NeedHelpButtonComponent {
  subs = new SubSink();
  rgbColor: string;
  @Input() text: string = "Need help?";
  @Input() token: string;

  constructor(private configurationService: ConfigurationService) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.rgbColor = c?.rgb;
        thisObject.text = c?.needHelpText;
      },
    );
  }
  onclick(): void {
    console.log("start userpilot with token " + this.token);
    Userpilot.trigger(this.token);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
